import {
  Badge,
  Controller,
  Group,
  useFormContext,
} from '@qred/components-library';
import { ComboboxItem } from '@qred/components-library/dist/lib/next/components/Combobox/Combobox.types';
import { Select } from '@qred/components-library/next';
import React from 'react';
import useTranslate from '~/hooks/useTranslate';
import { ILoanApplicationClient } from '~/interfaces/loanApplication';
import { StartApplicationForm } from '../StartApplication.schema';

const getOptionLabel = (client: ILoanApplicationClient): string => {
  if (client.company_no) {
    return `${client.company_name} (${client.company_no})`;
  }

  return client.company_name;
};

interface Props {
  clients: ILoanApplicationClient[];
  handleCompanySelect: (clientId: string) => void;
  companyIsNew: boolean;
}

export const CompanySelect = (props: Props) => {
  const { clients, handleCompanySelect, companyIsNew } = props;

  const t = useTranslate();
  const { control } = useFormContext<StartApplicationForm>();

  const clientOptions: ComboboxItem[] = [
    ...clients.map(
      (client): ComboboxItem => ({
        label: getOptionLabel(client),
        value: client.client_id.toString(),
      })
    ),
    {
      label: t('Onboarding.NewCompany') as string,
      value: 'other',
    },
  ];

  return (
    <Controller
      control={control}
      name="clientId"
      render={({ field, fieldState }) => {
        return (
          <Select
            label={t('Onboarding.SelectCompanySelectorDescriptionRlc')}
            data={clientOptions}
            searchable
            onChange={(value) => {
              if (value) {
                handleCompanySelect(value);
              }
            }}
            value={companyIsNew ? 'other' : field.value}
            renderOption={(item) => {
              if (item.option.value === 'other') {
                return item.option.label;
              }

              const client = clients.find(
                (_client) => _client.client_id.toString() === item.option.value
              );
              if (!client) return null;

              return (
                <Group align="center" justify="space-between">
                  {client.company_name}
                  {client.application_uuid &&
                    (client.has_inprogress_application ||
                      client.has_offer_to_sign) && (
                      <Badge
                        color={
                          client.has_offer_to_sign
                            ? 'success.500'
                            : 'warning.500'
                        }
                      >
                        {client.has_offer_to_sign
                          ? t('Onboarding.ActiveOffer')
                          : t('Onboarding.ActiveApplication')}
                      </Badge>
                    )}
                </Group>
              );
            }}
            error={fieldState.error?.message && t(fieldState.error.message)}
            allowDeselect={false}
          />
        );
      }}
    />
  );
};
